import { ExternalRates } from "@frec-js/common";
import { useObjectFeatureFlag } from "@frec-js/common-web";

export const useCompetitorRates = () => {
  return useObjectFeatureFlag<ExternalRates>(
    "external_rates",
    {
      loading: undefined,
      missing: {
        externalRates: [],
        tieredExternalRates: undefined,
        updatedAt: "",
      },
    },
    // null user because frec-web is non-logged in
    {
      user: null,
      isEmployee: false,
    },
  );
};
